import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const FillingGoalPieChart = () => {
  const [goal, setGoal] = useState(3000);
  const [filled, setFilled] = useState(0);
  const [editing, setEditing] = useState(false);
  const [inputGoal, setInputGoal] = useState(goal);

  useEffect(() => {
    fetch('/api/cylinders/summary')
      .then(res => res.json())
     .then(data => setFilled(data.filledThisMonth || 0));


    fetch('/api/fillingGoal/current')
      .then(res => res.json())
      .then(data => {
        if (data?.goal) {
          setGoal(data.goal);
          setInputGoal(data.goal);
        }
      });
  }, []);

  const saveGoal = () => {
    fetch('/api/fillingGoal', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ goal: inputGoal })
    })
      .then(res => res.json())
      .then(data => {
        setGoal(data.goal);
        setEditing(false);
      });
  };

  const percentage = Math.min(100, (filled / goal) * 100);

  const data = {
    labels: ['Progreso', 'Meta restante'],
    datasets: [
      {
        data: [filled, Math.max(goal - filled, 0)],
        backgroundColor: ['#4ADE80', 'rgba(234,242,245,0.12)']
      }
    ]
  };

  return (
    <div className="p-3">
      <h5>Progreso de Llenado</h5>
      {editing ? (
        <>
          <input
            type="number"
            value={inputGoal}
            onChange={e => setInputGoal(e.target.value)}
          />
          <button className="btn btn-sm btn-success ms-2" onClick={saveGoal}>Guardar</button>
        </>
      ) : (
        <div className="mb-2">
          <span>Meta: {goal} cilindros</span>
          <button className="btn btn-sm btn-outline-primary ms-2" onClick={() => setEditing(true)}>Editar</button>
        </div>
      )}
      <Pie data={data} />
      <p className="mt-2 text-center fw-bold">{percentage.toFixed(1)}% completado</p>
    </div>
  );
};

export default FillingGoalPieChart;
